import React, { useMemo } from 'react';
import { View, StyleSheet } from 'react-native';
import type { ImageStyle, ViewStyle } from 'react-native';
import RemoteImage from 'src/presentation/components/molecules/RemoteImage';
import { useContentWidth } from 'src/presentation/hooks/useContentWidth';
import Dimens from 'src/core/utils/Dimens';
import type { ApiContentBlockImage } from 'src/core/models/api/ApiContentBlock';

interface ContentBlockImageProps {
	data: ApiContentBlockImage;
	first?: boolean;
	last?: boolean;
}

export default function ContentBlockImage({ data, first }: ContentBlockImageProps) {
	const contentWidth = useContentWidth();

	const sizedStyles = useMemo(
		(): { container: ViewStyle; image: ImageStyle } => ({
			container: {
				width: contentWidth,
			},
			image: {
				height: 210,
				width: contentWidth,
			},
		}),
		[contentWidth],
	);

	return (
		<View style={[styles.container, sizedStyles.container, first ? styles.first : null]}>
			<RemoteImage style={sizedStyles.image} uri={data.data.cb_image} />
		</View>
	);
}

const styles = StyleSheet.create({
	container: {
		paddingTop: Dimens.padding8,
		paddingBottom: Dimens.padding8,
	},
	first: {
		paddingTop: Dimens.padding0,
	},
});
